<script>

import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import config from "../../config";
import pagination from "laravel-vue-pagination";
import { timeslotService } from "../../services";
import { debounce,success_message,error_message } from "../../Helper/helper";

export default {
  components: { Layout, PageHeader, pagination, timeslotService },
    data() {
        const { status,type,orderBy,sortBy,customer_type} = this.$route.query;
        return {
            title: this.trans.get('__JSON__.Sub Products'),
            url: null,
            debounce: false,
            items: [],
            checked: true,
            sortBy: sortBy || 'id',
            sortDesc: orderBy && orderBy != '' ? true : orderBy,
            loading: true,
            paginations: {},
            limit: 1,
            search: "",
            status: status == undefined ? '1' :status,
            type: type == undefined ? '' :type,
            customer_type: customer_type == undefined ? '' : customer_type,
            config: config,
            timeslotCount: "",
            searchData:debounce(()=>{
                if(!this.init){
                    const {status,type,orderBy,sortBy} = this.$data;
                    this.$router.replace({name: 'time-slot-list', query: {status,type,orderBy,sortBy,customer_type}})
                }
                this.getTimeSlot();
                this.init = false;
            },500),
            
            fields: [
                { key: "id", label: "#", sortable: true },
                { key: "from_time", label: "From Time", sortable: true },
                { key: "to_time", label: "To Time", sortable: false },
                { key: "type", label: "Day", sortable: true },
                { key: "customer_type", label: "Customer Type", sortable: true },
                { key: "status", label: "Status", sortable: false },
                { key: "action", label: "Action", sortable: false },
                
            ],
        };
    },
    mounted() {
        this.getTimeSlot();
    },
    methods: {
        sortingChanged(ctx) {
            this.sortBy = ctx.sortBy;
            this.sortDesc = ctx.sortDesc;
            this.getTimeSlot();
        },
        getTimeSlot(page) {
            this.loading = true;
            timeslotService
            .getTimeSlot({ 
                search: this.search,
                status: this.status,
                sortBy: this.sortBy,
                orderBy: this.sortDesc ? "desc" : "asc",
                page: page && page > 0 ? page : 1,
                type: this.type,
                customer_type: this.customer_type
            })
            .then((response) => {
                this.loading = false;
                this.paginations = response.data.result;
                this.items = response.data.result.data;
                this.timeslotCount = response.data.result.data.length;
            });
        },
        deleteTimeSlot(id){
            if(confirm("Do you really want to delete?")){
                timeslotService.deleteTimeSlot({id: id})
                .then(response => {
                    if (response.data.code === 200) {
                        this.getTimeSlot();
                        success_message(response.data.message);
                    } else {
                        error_message(response.data.message);
                    }
                });
            }
        }
    },
};

</script>

<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="page-title-box d-flex align-items-center justify-content-between icon-main-page" >
                    <div class="page-title-left">
                        <div class="avatar-xs mr-3 avatar-main-icon">
                            <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
                                <i class="bx bx-user-circle"></i>
                            </span>
                        </div>
                        <div class="report-tag">
                            <h4 class="mb-0 font-size-18" >{{ trans.trans('__JSON__.Time Slots') }}({{timeslotCount}})</h4>
                            <!-- <p><router-link :to="{ name: 'time-slot-list'}">{{ trans.get('__JSON__.Time Slots') }}</router-link>({{timeslotCount}})</p> -->
                        </div>
                    </div>
                    <div class="page-title-right d-flex">
                        <router-link :to="{name: 'time-slot-add',params: { product_id:this.$route.params.product_id}}" class="btn btn-success btn-rounded mr-2 add-btn">
                            <i class="mdi mdi-plus mr-1"></i>
                            {{ trans.get('__JSON__.Add Time Slot') }}
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="row list-table-main">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-2 offset-sm-6">
                                <div class="form-group">
                                <div class="date-range-list">
                                    <label>{{ trans.get('__JSON__.Customer Type') }} :</label>
                                    <select class="custom-select" v-model="customer_type" @change="searchData()">
                                    <option value="">{{ trans.get('__JSON__.All') }}</option>
                                    <option value="1">{{ trans.get('__JSON__.Business') }}</option>
                                    <option value="2" selected>{{ trans.get('__JSON__.Private') }}</option>
                                    </select>
                                </div>
                                </div>
                            </div>
                            <div class="col-sm-2">
                                <div class="form-group">
                                    <div class="date-range-list">
                                        <label>{{ trans.get('__JSON__.Status') }} :</label>
                                        <select class="custom-select" v-model="status" @change="searchData()">
                                        <option value="">{{ trans.get('__JSON__.All') }}</option>
                                        <option value="1" selected>{{ trans.get('__JSON__.Active') }}</option>
                                        <option value="0">{{ trans.get('__JSON__.Inactive') }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-2">
                                <div class="form-group">
                                    <div class="date-range-list">
                                        <label>{{ trans.get('__JSON__.Days Type') }} :</label>
                                        <select class="custom-select" v-model="type" @change="searchData()">
                                        <option value="">{{ trans.get('__JSON__.All') }}</option>
                                        <option value="0" selected>{{ trans.get('__JSON__.All Days') }}</option>
                                        <option value="1">{{ trans.get('__JSON__.Special Days') }}</option>
                                        <option value="2">{{ trans.get('__JSON__.Today') }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="col-sm-2">
                                <div class="date-range-list">
                                    <label>{{ trans.get('__JSON__.Search') }} :</label>
                                    <div class="text-sm-right">
                                        <div class="search-box mr-2 d-inline-block">
                                            <div class="position-relative">
                                                <input
                                                type="text"
                                                class="form-control"
                                                id="search"
                                                @input="searchData()"
                                                v-model="search"
                                                :placeholder="trans.get('__JSON__.Search Placeholder')"
                                                />
                                                <i class="bx bx-search-alt search-icon"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                        <div class="row">
                            <div class="col-12 table-main-list timeslot-table table-responsive">
                                <b-table
                                :items="items"
                                :fields="fields"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                :no-local-sorting="true"
                                @sort-changed="sortingChanged"
                                :busy="loading"
                                show-empty
                                >
                                <template #table-busy>
                                    <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>{{trans.get('__JSON__.Loading...')}}</strong>
                                    </div>
                                </template>
                                
                                <template v-slot:cell(id)="data">
                                    <span>{{ data.item.id }}</span>
                                </template>
                                
                                <template v-slot:cell(from_time)="data">
                                    <span>{{ data.item.from_time }}</span>
                                </template>

                                <template v-slot:cell(to_time)="data">
                                    <span>{{ data.item.to_time }}</span>
                                </template>
                                
                                <template v-slot:cell(type)="data">
                                    <div
                                    v-if="data.item.type == '0'"
                                    class="badge badge-pill badge-soft-success font-size-12"
                                    >{{ data.item.value }}</div>
                                    <div
                                    v-else-if="data.item.type == '1'"
                                    class="badge badge-pill badge-soft-success font-size-12"
                                    >{{ data.item.value }}</div>
                                    <div
                                    v-else-if="data.item.type == '2'"
                                    class="badge badge-pill badge-soft-success font-size-12"
                                    >{{ moment(data.item.value).format('MM-DD-YYYY') }}</div>
                                </template>
                                <template v-slot:cell(customer_type)="data">
                                    <div
                                    v-if="data.item.customer_type == '1'"
                                    class="badge badge-pill badge-soft-danger font-size-12"
                                    >{{ trans.get('__JSON__.Business') }}</div>
                                    <div
                                    v-if="data.item.customer_type == '2'"
                                    class="badge badge-pill badge-soft-success font-size-12"
                                    >{{ trans.get('__JSON__.Private') }}</div>
                                </template>
                                <template v-slot:cell(status)="data">
                                    <div
                                    v-if="data.item.status == '0'"
                                    class="badge badge-pill badge-soft-danger font-size-12"
                                    >{{ trans.get('__JSON__.Inactive') }}</div>
                                    <div
                                    v-else
                                    class="badge badge-pill badge-soft-success font-size-12"
                                    >{{ trans.get('__JSON__.Active') }}</div>
                                </template>

                                <template v-slot:cell(action)="data">
                                    <router-link
                                    :to="{name: 'time-slot-edit',params: { id:base64(data.item.id)}}"
                                    class="btn btn-success btn-sm btn-rounded"
                                    >Edit</router-link>

                                    <button
                                        type="button"
                                        @click="deleteTimeSlot(base64(data.item.id))"
                                        class="btn btn-danger btn-sm btn-rounded ml-1"
                                    >{{ trans.get('__JSON__.Delete') }}</button>
                                </template>

                                <template #empty>
                                    <p class="text-center">{{ trans.get('__JSON__.No TimeSlot') }}</p>
                                </template>
                                </b-table>
                            </div>
                            <div class="row col-sm-5 offset-sm-7">
                                <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                    <!-- pagination -->
                                        <pagination
                                            :data="paginations"
                                            :limit="limit"
                                            @pagination-change-page="getTimeSlot"
                                        ></pagination>
                                    </ul>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>